<div class="root-container">
  <form class="form-group" [formGroup]="form()">
    <div class="row">
        <!-- First name Field -->
        <div class="col-lg-4 col-md-6">
            <label for="first_name" class="mb-2 label-required">First Name</label>
            <input
                    type="text"
                    id="first_name"
                    name="first_name"
                    placeholder="Enter your first name"
                    class="form-control"
                    formControlName="first_name"
                    maxlength="50"
                    required
            />

            <div class="error-label">
                <validation-error
                        [form]="form()"
                        controlName="first_name"
                        [validation]="{required: 'First name is required',
                                        emojiNotAllowed: 'Emoji is not allowed',
                                        maxlength: 'First name must be 50 characters or less',
                                        pattern: 'Digits and Special characters are not allowed'}"
                />
            </div>
        </div>

        <!-- Middle name Field -->
        <div class="col-lg-4 col-md-6">
            <label for="middle_name" class="mb-2">Middle Name</label>
            <input
                    type="text"
                    id="middle_name"
                    name="middle_name"
                    placeholder="Enter your middle name"
                    class="form-control"
                    maxlength="50"
                    formControlName="middle_name"
            />
            <div class="error-label">
                <validation-error
                        [form]="form()"
                        controlName="middle_name"
                        [validation]="{
                          required: 'Middle name is required',
                          emojiNotAllowed: 'Emoji is not allowed',
                          maxlength: 'Middle name must be 50 characters or less',
                          pattern: 'Digits and Special characters are not allowed',
                        }"
                />
            </div>
        </div>

        <!-- Last name Field -->
        <div class="col-lg-4 col-md-6">
            <label for="last_name" class="mb-2 label-required">Last Name</label>
            <input
                    type="text"
                    id="last_name"
                    name="last_name"
                    placeholder="Enter your last name"
                    class="form-control"
                    formControlName="last_name"
                    required
                    maxlength="50"
            />
            <div class="error-label">
                <validation-error
                        [form]="form()"
                        controlName="last_name"
                        [validation]="{
                          required: 'Last name is required',
                          emojiNotAllowed: 'Emoji is not allowed',
                          maxlength: 'Last name must be 50 characters or less',
                          pattern: 'Digits and Special characters are not allowed',
                        }"
                />
            </div>
        </div>

        <!-- Suffix Field -->
        <div class="col-lg-4 col-md-6">
            <label for="suffix" class="mb-2">Suffix</label>
            <input
                    type="text"
                    id="suffix"
                    name="suffix"
                    placeholder="Enter your suffix"
                    class="form-control"
                    maxlength="3"
                    formControlName="suffix"
            />
            <div class="error-label">
                <validation-error
                        [form]="form()"
                        controlName="suffix"
                        [validation]="{
                          emojiNotAllowed: 'Emoji is not allowed',
                          maxlength: 'Suffix must be 10 characters or less',
                        }"
                />
            </div>
        </div>

        <!-- Mobile Field -->
        <div class="col-lg-4 col-md-6">
            <label for="mobile" class="mb-2 label-required">Mobile</label>
            <input
                    type="text"
                    id="mobile"
                    name="mobile"
                    placeholder="e.g +639xxxxxxxxxx"
                    class="form-control"
                    formControlName="mobile"
                    required
                    maxlength="13"
            />
            <div class="error-label" style="min-height: 2.6rem">
                <validation-error
                        [form]="form()"
                        controlName="mobile"
                        [validation]="{
                          required: 'Mobile number is required',
                          emojiNotAllowed: 'Emoji is not allowed',
                          maxlength: 'Mobile number must be 13 characters',
                          pattern: 'Mobile must start with +639 and contain 9 digits',
                        }"
                />
            </div>
        </div>
    </div>
  </form>
</div>
